export const GET_PERMISSIONS_LIST = "GET_PERMISSIONS_LIST"
export const GET_PERMISSIONS_LIST_SUCCESS = "GET_PERMISSIONS_LIST_SUCCESS"
export const GET_PERMISSIONS_LIST_FAIL = "GET_PERMISSIONS_LIST_FAIL"

export const ADD_NEW_PERMISSION = "ADD_NEW_PERMISSION"
export const ADD_NEW_PERMISSION_SUCCESS = "ADD_NEW_PERMISSION_SUCCESS"
export const ADD_NEW_PERMISSION_FAIL = "ADD_NEW_PERMISSION_FAIL"

export const UPDATE_PERMISSION = "UPDATE_PERMISSION"
export const UPDATE_PERMISSION_SUCCESS = "UPDATE_PERMISSION_SUCCESS"
export const UPDATE_PERMISSION_FAIL = "UPDATE_PERMISSION_FAIL"

export const DELETE_PERMISSION = "DELETE_PERMISSION"
export const DELETE_PERMISSION_SUCCESS = "DELETE_PERMISSION_SUCCESS"
export const DELETE_PERMISSION_FAIL = "DELETE_PERMISSION_FAIL"
